import React, { Component } from 'react';
import { debounce } from 'lodash';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Creators as EventsActions, Selectors as EventsSelectors } from 'store/ducks/events';

import { Access } from 'common';
import { Form } from 'components';

class Filters extends Component {
  state = {
    filter: this.props.filter,
    status: [
      { value: '', label: 'Todos' },
      { value: 'approve', label: 'Aprovado' },
      { value: 'reproved', label: 'Reprovado' },
      { value: 'pending', label: 'Pendente' },
      { value: 'expired', label: 'Expirado' },
    ],
    stores: [],
  };

  constructor(props) {
    super(props);

    const { getEventsLocalRequest } = props;

    this.handleSearchStores = debounce(getEventsLocalRequest, 300);
  }

  componentDidMount() {
    const { getEventsLocalRequest } = this.props;

    getEventsLocalRequest();
  }

  componentDidUpdate(oldProps) {
    const { filter } = this.props;

    if (oldProps.filter !== filter) {
      this.setState({ filter });
    }
  }

  handleFindStore = query => {
    this.handleSearchStores(query);
  };

  render() {
    const { filter, status } = this.state;
    const { locals, onChange, onClean } = this.props;

    return (
      <Form className="row">
        <Form.Field className="col-md-3">
          <Form.Label>Lojas</Form.Label>
          <Form.Select
            placeholder="Lojas"
            value={filter.local}
            options={locals.data}
            onChange={value => onChange('local', value)}
            onInputChange={this.handleFindStore}
            noOptionsMessage={() => 'Loja não encontrada'}
            isDisabled={!!Access.lockedStore()}
          />
        </Form.Field>

        <Form.Field className="col-md-2">
          <Form.Label>Período, de</Form.Label>
          <Form.Icon name="calendar">
            <Form.DatePicker
              dateFormat="dd/MM/yyyy"
              selected={filter.start_at}
              onChange={value => onChange('start_at', value)}
            />
          </Form.Icon>
        </Form.Field>

        <Form.Field className="col-md-2">
          <Form.Label>Período, até</Form.Label>
          <Form.Icon name="calendar">
            <Form.DatePicker
              dateFormat="dd/MM/yyyy"
              selected={filter.end_at}
              onChange={value => onChange('end_at', value)}
              minDate={filter.start_at}
              disabled={filter.start_at === null}
            />
          </Form.Icon>
        </Form.Field>

        <Form.Field className="col-md-2">
          <Form.Label>Situação</Form.Label>
          <Form.Select
            placeholder="Situação"
            options={status}
            onChange={value => onChange('status', value)}
            value={filter.status}
          />
        </Form.Field>

        <Form.Field className="col-md-3">
          <Form.Button className="button-clean-filter" onClick={onClean}>
            Resetar Filtro
          </Form.Button>
        </Form.Field>
      </Form>
    );
  }
}

const mapState = state => ({
  locals: {
    ...state.events.locals,
    data: EventsSelectors.locals(state.events.locals.data),
  },

  stores: {
    ...state.events.stores,
    data: EventsSelectors.stores(state.events.stores.data),
  },
});

const mapActions = dispatch => bindActionCreators(EventsActions, dispatch);

export default connect(
  mapState,
  mapActions,
)(Filters);
